export default __webpack_public_path__ + "fonts/FuturaStd-Heavy.woff";